import { GemColors } from '../Color'
import { wideGamutColor } from '../Color/utils/wideGamutColor'

/**
 * Semi-transparent colors used as an overlay to convey hover or active states.
 * Typically applied to the ::before pseudo-element
 */
export const Overlay = {
  BL200: {
    '06': wideGamutColor(GemColors.B450, 0.06),
    '08': wideGamutColor(GemColors.B450, 0.08),
    '16': wideGamutColor(GemColors.B450, 0.16),
  },
  BD200: {
    '16': wideGamutColor(GemColors.B400, 0.16),
    '24': wideGamutColor(GemColors.B400, 0.24),
  },
  P100: {
    '24': wideGamutColor(GemColors.P100, 0.24),
    '72': wideGamutColor(GemColors.P100, 0.72),
  },
  P700: {
    '24': wideGamutColor(GemColors.P700, 0.24),
    '72': wideGamutColor(GemColors.P700, 0.72),
  },
  N200: {
    '08': wideGamutColor(GemColors.N200, 0.08),
    '12': wideGamutColor(GemColors.N200, 0.12),
    '16': wideGamutColor(GemColors.N200, 0.16),
    '24': wideGamutColor(GemColors.N200, 0.24),
  },
  White: {
    '12': wideGamutColor('#FFFFFF', 0.12),
    '24': wideGamutColor('#FFFFFF', 0.24),
    '48': wideGamutColor('#FFFFFF', 0.48),
    '72': wideGamutColor('#FFFFFF', 0.72),
  },
  Black: {
    '12': wideGamutColor('#000000', 0.12),
    '24': wideGamutColor('#000000', 0.24),
    '48': wideGamutColor('#000000', 0.48),
    '72': wideGamutColor('#000000', 0.72),
  },
}
